import { useRef, useState } from "react";
import { ImagePlus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { uploadPhoto } from "./ImageUpload";

export const FlyerQuickUpload = ({ show, onDone }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const image_url = await uploadPhoto(file);
      const { id, ...body } = show;
      await api.put(`/admin/shows/${id}`, { ...body, image_url });
      toast.success("Flyer saved");
      onDone();
    } catch (err) {
      toast.error(errMsg(err));
    }
    setBusy(false);
  };

  return (
    <>
      <input ref={input} type="file" accept="image/*" onChange={pick} className="hidden" data-testid={`admin-show-${show.id}-flyer-input`} />
      <button type="button" data-testid={`admin-show-${show.id}-flyer-btn`} disabled={busy} onClick={() => input.current?.click()} className="inline-flex items-center gap-2 border border-[#56ED4A] text-[#56ED4A] hover:bg-[#56ED4A] hover:text-black transition-colors px-3 py-2 font-mono text-[11px] uppercase tracking-[0.2em] disabled:opacity-60">
        {busy ? <Loader2 size={13} className="animate-spin" /> : <ImagePlus size={13} />} {show.image_url ? "Change flyer" : "Add flyer"}
      </button>
    </>
  );
};
